/**
 * @generated SignedSource<<d5f8cda12d86f707b0fbc1e0906eb664>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeductionType = "employmentIncrease" | "employmentIntegration" | "sme" | "socialInsurancePremium" | "startup";
export type ErrorType = "ERR_ADSLOT" | "ERR_CARD_BIRTH" | "ERR_CARD_EXPIRED" | "ERR_CARD_NUMBER" | "ERR_CARD_PASSWORD" | "ERR_CARD_PASSWORD_FIVE_TIMES" | "ERR_CREATE_SURVEY_ANSWER" | "ERR_DUPLICATE_APPLY" | "ERR_ETC" | "ERR_EXIST_FINISH_REFUND" | "ERR_EXIST_SEARCH_HISTORY" | "ERR_EXPIRE_URL" | "ERR_HECTO_ETC" | "ERR_HOMETAX_BLOCK_ID" | "ERR_HOMETAX_CALCULATE" | "ERR_HOMETAX_COLLECT" | "ERR_HOMETAX_ETC" | "ERR_HOMETAX_EXPIRE_CERT" | "ERR_HOMETAX_IMPOSSIBLE" | "ERR_HOMETAX_INPUT" | "ERR_HOMETAX_NO_BMAN" | "ERR_HOMETAX_NO_CONTINUE_BMAN" | "ERR_HOMETAX_NO_CORPS_ID" | "ERR_HOMETAX_NO_INCOME_TAX" | "ERR_HOMETAX_NO_JUMIN_ID" | "ERR_HOMETAX_NO_REGIST_CERT" | "ERR_HOMETAX_NO_USER" | "ERR_HOMETAX_OVERLOAD" | "ERR_HOMETAX_PASSWORD" | "ERR_HOMETAX_PASSWORD_CHANGE_REQUEST" | "ERR_HOMETAX_REG_NO" | "ERR_HOMETAX_SERVER_FIX" | "ERR_HOMETAX_SESSION" | "ERR_HOMETAX_SIMPLE_AUTH" | "ERR_HOMETAX_TIMEOUT" | "ERR_LEAVE_REASON" | "ERR_LEAVE_REASON_LOG" | "ERR_NON_PRODUCT_PROMOTION" | "ERR_NOT_EXIST_HISTORY" | "ERR_NOT_EXIST_YEAR_END_TAX_SETTLEMENT" | "ERR_NO_EQUAL_TIN" | "ERR_PROMOTION" | "ERR_SSO" | "ERR_SURVEY" | "ERR_SURVEY_ANSWER" | "ERR_SURVEY_COMPLETED" | "ERR_SURVEY_EXPIRED" | "ERR_UPDATE_SURVEY_ANSWER" | "ERR_USER" | "ERR_USER_ACTION_LOG" | "ERR_USER_PHONE";
export type initSurveyQuery$variables = {
  refundHistoryId: string;
};
export type initSurveyQuery$data = {
  readonly bznavRefund: {
    readonly imputedYear: {
      readonly indis: string;
    };
  };
  readonly getSurveyBusinessAnswer: {
    readonly businessAnswer: ReadonlyArray<{
      readonly bmanTin: string | null | undefined;
      readonly isCompleted: boolean | null | undefined;
    }> | null | undefined;
  };
  readonly getSurveyBusinessInfo: {
    readonly business: ReadonlyArray<{
      readonly bmanTin: string | null | undefined;
      readonly totalAmount: number | null | undefined;
    }> | null | undefined;
  };
  readonly getSurveyEmployees: {
    readonly employees: ReadonlyArray<{
      readonly attrYears: ReadonlyArray<string>;
      readonly birthday: string | null | undefined;
      readonly ieNm: string;
      readonly indvTin: string;
    }> | null | undefined;
    readonly result: boolean;
  };
  readonly getSurveyStatus: {
    readonly errors: {
      readonly code: ErrorType;
      readonly message: string | null | undefined;
    } | null | undefined;
    readonly result: boolean;
    readonly surveyStatus: {
      readonly deductionTypes: ReadonlyArray<DeductionType>;
      readonly expiredAt: string | null | undefined;
      readonly isCompleted: boolean;
      readonly surveyAnswerId: string | null | undefined;
      readonly totalAmount: number | null | undefined;
      readonly txprNm: string | null | undefined;
    } | null | undefined;
  };
};
export type initSurveyQuery = {
  response: initSurveyQuery$data;
  variables: initSurveyQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "refundHistoryId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "refundHistoryId",
    "variableName": "refundHistoryId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "result",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalAmount",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCompleted",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bmanTin",
  "storageKey": null
},
v6 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "BznavRefundOutput",
    "kind": "LinkedField",
    "name": "bznavRefund",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ImputedYearOutput",
        "kind": "LinkedField",
        "name": "imputedYear",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "indis",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": (v1/*: any*/),
    "concreteType": "SurveyStatusOutput",
    "kind": "LinkedField",
    "name": "getSurveyStatus",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Errors",
        "kind": "LinkedField",
        "name": "errors",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SurveyStatus",
        "kind": "LinkedField",
        "name": "surveyStatus",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "surveyAnswerId",
            "storageKey": null
          },
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "txprNm",
            "storageKey": null
          },
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "deductionTypes",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "expiredAt",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": (v1/*: any*/),
    "concreteType": "SurveyBusinessInfoOutput",
    "kind": "LinkedField",
    "name": "getSurveyBusinessInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SurveyBusinessInfo",
        "kind": "LinkedField",
        "name": "business",
        "plural": true,
        "selections": [
          (v5/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": (v1/*: any*/),
    "concreteType": "SurveyBusinessAnswerOutput",
    "kind": "LinkedField",
    "name": "getSurveyBusinessAnswer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SurveyBusinessAnswer",
        "kind": "LinkedField",
        "name": "businessAnswer",
        "plural": true,
        "selections": [
          (v5/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": (v1/*: any*/),
    "concreteType": "SurveyEmployeesOutput",
    "kind": "LinkedField",
    "name": "getSurveyEmployees",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "SurveyEmployee",
        "kind": "LinkedField",
        "name": "employees",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "indvTin",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ieNm",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "birthday",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "attrYears",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "initSurveyQuery",
    "selections": (v6/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "initSurveyQuery",
    "selections": (v6/*: any*/)
  },
  "params": {
    "cacheID": "8015cf9c2572a8e953e35a9e82722c0b",
    "id": null,
    "metadata": {},
    "name": "initSurveyQuery",
    "operationKind": "query",
    "text": "query initSurveyQuery(\n  $refundHistoryId: String!\n) {\n  bznavRefund {\n    imputedYear {\n      indis\n    }\n  }\n  getSurveyStatus(refundHistoryId: $refundHistoryId) {\n    result\n    errors {\n      code\n      message\n    }\n    surveyStatus {\n      surveyAnswerId\n      totalAmount\n      txprNm\n      isCompleted\n      deductionTypes\n      expiredAt\n    }\n  }\n  getSurveyBusinessInfo(refundHistoryId: $refundHistoryId) {\n    business {\n      bmanTin\n      totalAmount\n    }\n  }\n  getSurveyBusinessAnswer(refundHistoryId: $refundHistoryId) {\n    businessAnswer {\n      bmanTin\n      isCompleted\n    }\n  }\n  getSurveyEmployees(refundHistoryId: $refundHistoryId) {\n    result\n    employees {\n      indvTin\n      ieNm\n      birthday\n      attrYears\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "99702259e7fb7a65c386bc9e96ab3d91";

export default node;
